import { lazy } from 'react';

// Asset Lifecycle (Asset Management)
// V3 surface unifies the prior 9-page split (AssetsV2 + 8 separate sub-pages
// for warranties/leases/disposal/refresh/renewals/certs/licenses) into one
// six-tab lifecycle narrative. Sub-routes still mount V3 with the right
// initial tab via URL.
export const AssetDashboard = lazy(() => import('@/capabilities/asset-lifecycle/pages/Assets'));

export const CertificateList = lazy(() => import('@/capabilities/asset-lifecycle/pages/Assets'));

export const LicenseInventory = lazy(() => import('@/capabilities/asset-lifecycle/pages/Assets'));

export const RenewalCalendar = lazy(() => import('@/capabilities/asset-lifecycle/pages/Assets'));

export const WarrantyTracker = lazy(() => import('@/capabilities/asset-lifecycle/pages/Assets'));

export const LeaseTracker = lazy(() => import('@/capabilities/asset-lifecycle/pages/Assets'));

export const AssetDisposal = lazy(() => import('@/capabilities/asset-lifecycle/pages/Assets'));

export const RefreshCycle = lazy(() => import('@/capabilities/asset-lifecycle/pages/Assets'));

export const AssetRegistry = lazy(() => import('@/capabilities/asset-lifecycle/pages/Assets'));

export const ServiceDesk = lazy(() =>
  import('@/capabilities/asset-lifecycle/pages/ServiceDesk').then((m) => ({ default: m.ServiceDesk }))
);

export const SiteDocumentation = lazy(() =>
  import('@/capabilities/asset-lifecycle/pages/SiteDocumentation').then((m) => ({ default: m.SiteDocumentation }))
);

export const UptimeMonitor = lazy(() =>
  import('@/capabilities/asset-lifecycle/pages/UptimeMonitor').then((m) => ({ default: m.UptimeMonitor }))
);

export const DomainTracker = lazy(() =>
  import('@/capabilities/asset-lifecycle/pages/DomainTracker').then((m) => ({ default: m.DomainTracker }))
);
